"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CalendarInput_meta_1 = require("../CalendarInput.meta");
var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");
var Button_1 = __importDefault(require("../../Button/Button"));
exports.default = InjectedStyledComponent_1.InjectedStyledComponent(Button_1.default, CalendarInput_meta_1.CALENDAR_INPUT_CATEGORY_KEY, CalendarInput_meta_1.CALENDAR_INPUT_COMPONENT_KEY, ['monthButtonNext']);
